import { StateSchema } from '@/shared/types/store';

export const getIsAuth = (state: StateSchema) => state.admin.isAuth;
export const getAdminIsLoaded = (state: StateSchema) => state.admin.isLoaded;
export const getAdminProfile = (state: StateSchema) => state.admin.profile;
